import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { categorySwitch, skipSet } from '../../store/filterSlice';
import { useTranslation } from 'react-i18next';
import ExhibitorsListSwitch from './ListSwitch';
export const SHORT_LIST_LENGTH = 3;
//
// Вспомогательный компонент для отображения списка категорий.
// Это может быть или дополнительная, или специальная категория,
// или подкатегория из основной категории.
//
// TODO: count - число компаний в категории, пока не используем.
//
const FilterCategoryList = ({ list, title, count, border = false }) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const dispatch = useDispatch();
    const filter = useSelector(state => state.filter);
    const [ display, setDisplay ] = useState(false);
    const [ listClass, setListClass ] = useState('list-open');
    const [ longList, setLongList ] = useState([]);
    const [ showList, setShowList ] = useState([]);
    // Посчитываем общее число экспонентов по категориям
    // чтобы узнать надо ли вообще показывать список.
    // Заодно уберем из списка категории, в которых нет участников.
    useEffect(() => {
        setDisplay(false);
        setLongList([]);
        setShowList([]);

        let count = 0;
        let longList = [];

        list.forEach(item => {
            count += item.exhibitors_count;
            if(item.exhibitors_count) longList.push(item);
        });

        if(count) setDisplay(true);
        setLongList(longList);
        setShowList(longList.slice(0, SHORT_LIST_LENGTH));
    }, [ list ]);

    const onSwitch = (category_id) => {
        dispatch(categorySwitch(category_id));
        dispatch(skipSet(0));
    };

    // Переключаем отображения всего списка или его краткого варианта
    const onSwitchList = () => {
        if(showList.length === longList.length) {
            setShowList(longList.slice(0, SHORT_LIST_LENGTH));
        } else {
            setShowList(longList);
        }
    };

    // В категориях нет участников, поэтому их показывать не надо
    if(!display) return null;

    return (<>
        <ExhibitorsListSwitch title={title} setListClass={setListClass} count={count} border={border}/>
        <div className={listClass}>
        {showList.map(category => (
            <div
                key={category._id}
                onClick={() => onSwitch(category._id)}
                className={filter.categories.indexOf(category._id) < 0 ? 'item' : 'item check'}
            >
                <span className='icon'>
                    <FontAwesomeIcon
                        icon={filter.categories.indexOf(category._id) < 0 ? faSquare : faSquareCheck}
                    />
                </span>
                <div className='text'>
                    {category.name[lang]}&nbsp;
                    <small style={{color:'var(--gray-color)'}}>
                        ({category.exhibitors_count})
                    </small>
                </div>
            </div>
        ))}
        {longList.length > SHORT_LIST_LENGTH && <div className='right'>
            <span className='small a' onClick={() => onSwitchList()}>
                {showList.length === longList.length ? t('common.less') : t('common.more')}
            </span>
        </div>}
        </div>
    </>);
};

export default FilterCategoryList;
